var getServiceSlug = function getServiceSlug(factsheet) {
  var _factsheet$find, _factsheet$find$eleme, _factsheet$find$eleme2;
  return (factsheet == null ? void 0 : (_factsheet$find = factsheet.find(function (item) {
    return (item == null ? void 0 : item.slug) === 'ficha-tecnica';
  })) == null ? void 0 : (_factsheet$find$eleme = _factsheet$find.elements.find(function (item) {
    return (item == null ? void 0 : item.keyName) === 'Seguro';
  })) == null ? void 0 : (_factsheet$find$eleme2 = _factsheet$find$eleme.elements[0]) == null ? void 0 : _factsheet$find$eleme2.value) || '';
};
export default getServiceSlug;